import React from 'react';
import { StarIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-6 sm:py-10 px-4" data-id="element-79">
      <div className="max-w-2xl mx-auto text-center" data-id="element-80">
        <h1 className="text-2xl sm:text-4xl font-heading font-bold text-brand-primary leading-tight mb-4" data-id="element-81">
          Riattiva la tua Tiroide e ritrova la tua silhouette con il gusto della
          cucina italiana, pronti in 15 minuti.
        </h1>

        <p className="text-sm sm:text-base text-brand-text leading-relaxed mb-4" data-id="element-82">
          Il primo sistema "Gusta e Guarisci" con 60 Ricette mirate per
          l'Ipotiroidismo. Recupera la tua energia, elimina il gonfiore e
          sconfiggi la stanchezza cronica.
        </p>

        <div className="mb-4" data-id="element-83">
          <h2 className="text-lg sm:text-xl font-heading font-bold text-brand-primary mb-2" data-id="element-84">
            Tiroide Felice — Il Kit Completo per il Risveglio Metabolico
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-85">
            <div className="flex" data-id="element-86">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-500 fill-current" data-id="element-87" />)}
            </div>
            <span className="text-sm font-bold" data-id="element-88">4.9/5</span>
            <span className="text-xs text-brand-muted" data-id="element-89">
              (+800 recensioni verificate)
            </span>
          </div>
          <p className="text-sm text-brand-accent font-bold" data-id="element-90">
            🔥 127 donne hanno scelto questo Protocollo oggi
          </p>
        </div>

        <button onClick={scrollToPricing} className="block w-full mb-6 cursor-pointer" data-id="element-91">
          <img src="https://cdn.magicpatterns.com/uploads/hxWWe9evRkDRdJiYK58W6j/tiroides-italia-_1_.webp" alt="Tiroide Felice - Kit Completo" className="w-full h-auto object-contain" loading="eager" data-id="element-92" />
        </button>

        <button onClick={scrollToPricing} className="w-full bg-brand-accent hover:bg-brand-accentHover text-white font-bold py-4 px-6 rounded-lg uppercase tracking-wide text-sm sm:text-base transition-colors mb-4" data-id="element-93">
          🚀 SÌ! VOGLIO RIATTIVARE IL MIO METABOLISMO
        </button>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-xs text-brand-muted mb-4" data-id="element-94">
          <span data-id="element-95">⚡ Accesso Immediato</span>
          <span data-id="element-96">•</span>
          <span data-id="element-97">🛡️ Garanzia di 14 giorni</span>
          <span data-id="element-98">•</span>
          <span data-id="element-99">💳 Pagamento Unico</span>
        </div>

        <p className="text-sm font-bold text-brand-primary" data-id="element-100">
          🇮🇹 La risorsa N.1 scelta da oltre 800 donne in tutta Italia.
        </p>
      </div>
    </section>;
}